module.exports = __webpack_public_path__ + "media/react/assets/Goals-fb7fd8dd0af761ed05e75372d646f758.svg";